module.exports = __webpack_public_path__ + "img/pet_sad.126ce07e.svg";